import { z } from 'zod';

export type Permission = z.infer<typeof permissionSchema>;
export const permissionSchema = z.enum(['download', 'upload', 'change-settings', 'manage-users']);
